import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { callApp } from '@ifeng/callapp';
import Grounds from 'ThreeTerminal_base/grounds';
import styles from './index.css';

class BigShot extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        viewData: [],
        isShowMoreBtn: true,
    };

    loadNum = 3;

    componentDidMount() {
        this.setState({
            viewData: this.props.content.slice(0, 3),
        });
    }

    isClient = () => {
        return window && typeof window.grounds !== 'undefined';
    };

    handleMoreBtn = () => {
        const { content } = this.props;

        if (this.isClient()) {
            this.loadNum = this.loadNum + 3;

            this.setState({
                viewData: content.slice(0, this.loadNum),
                isShowMoreBtn: this.loadNum + 3 < content.length,
            });
        } else {
            callApp({
                client: 'newsApp',
                docType: 'web',
                pid: 'https://ishare.ifeng.com/c/s/80kdzDaUKoa',
                kind: 'inter_dsjzt01',
                noKindFrom: 1,
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191364941',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8819',
            });
        }
    };

    handlegotoUrl = item => {
        if (this.isClient()) {
            switch (item.type) {
                case 'article':
                    return window.grounds.dispatch('doc', `ucms_${item.base62Id}`);
                case 'video':
                    return window.grounds.dispatch('phvideo', `ucms_${item.base62Id}`);
                case 'slide':
                    return window.grounds.dispatch(
                        'slide',
                        `https://nine.ifeng.com/GetNewsDocs?aid=ucms_${item.base62Id}`,
                    );
                case 'special':
                    return window.grounds.dispatch(
                        'topic3',
                        `https://nine.ifeng.com/newTopic?topicid=${item.base62Id}&json=y`,
                    );
                default:
                    return window.grounds.dispatch('web', item.url);
            }
        } else {
            location.href = item.url;
        }
    };

    render() {
        const { viewData, isShowMoreBtn } = this.state;

        return (
            <div className={styles.bigShot}>
                <div className={styles.bigShotMd}>
                    <img
                        className={styles.bigShotMdImg}
                        src="https://x0.ifengimg.com/ucms/2020_43/46E2E012D0AEB61981110E5C46DC9EBC671B460D_w254_h114.png"
                    />
                </div>
                <div className={styles.bigShotBd}>
                    {viewData.map((item, index) => (
                        <div key={index} className={styles.bigShotBox}>
                            <div className={styles.bigShotBoxQ}>{item.question}</div>
                            <div className={styles.bigShotBoxA}>
                                {item.data &&
                                    item.data.map((items, indexs) => (
                                        <div key={indexs} className={styles.bigShotBdText}>
                                            <div className={styles.bigShotBdInfo}>
                                                {items.faceUrl && (
                                                    <img className={styles.bigShotBdPic} src={items.faceUrl} />
                                                )}
                                                <div className={styles.bigShotBdBref}>
                                                    <h2 className={styles.bigShotBdName}>{items.name}</h2>
                                                    <p className={styles.bigShotBdSource}>{items.title}</p>
                                                </div>
                                            </div>
                                            <div className={styles.bigShotBdComment}>
                                                <p className={styles.bigShotBdCommentText}>{items.viewpoint}</p>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    ))}
                </div>
                {isShowMoreBtn && (
                    <div className={styles.viewMore} onClick={this.handleMoreBtn}>
                        <span className={styles.viewMoreBtn}>查看更多</span>
                    </div>
                )}
            </div>
        );
    }
}

export default errorBoundary(BigShot);
